import { transformActions } from 'utils/';
import { GET_ITEM_UPLOAD } from 'actions/types';

const initialState = { data: [], isLoading: false };

/**
 * @description Stores uploaded items array details in redux state
 * @returns {[]}
 * @param {[]} state
 * @param {{}} action
 */
export function upload(state = initialState, action) {
  const { type, payload } = action;
  const actions = [GET_ITEM_UPLOAD];
  const success = transformActions(actions, 'SUCCESS');
  const failure = transformActions(actions, 'FAILURE');
  if (type === GET_ITEM_UPLOAD) {
    return { data: [], isLoading: true };
  }
  if (success.includes(type)) {
    return { data: payload, isLoading: false };
  }
  if (failure.includes(type)) {
    return { data: [], isLoading: false };
  }
  return state;
}
